import { useState } from 'react';

export const useSuspenseListener = (): {
  isSuspending: boolean | undefined;
} => {
  const [isSuspending, setIsSuspending] = useState<boolean>();
  const suspenseChild = document.getElementById('suspense-child');
  const observer = new MutationObserver(function () {
    if (suspenseChild?.style.display !== 'none') {
      setIsSuspending(false);
    } else {
      setIsSuspending(true);
    }
  });

  suspenseChild && observer.observe(suspenseChild, { attributes: true });

  return {
    isSuspending,
  };
};
